import React, { useState } from "react";
import { UNIDADES as UNIDADES_CENTRAL } from "../constants/unidades";

// Auditorías cubre las 5 unidades (incluye Urban) — función nueva que no
// existe en Urban Reportes.
const UNIDADES = UNIDADES_CENTRAL;

// Pantalla de acceso rápido para Gerente de Higiene y Calidad y Supervisor de
// Tiendas — pensada para entrar y auditar desde el celular sin pasar por el
// menú completo del sistema.
export default function AccesoRapidoAuditorias({ nombreUsuario, onElegirTienda, onEntrarSistema, onLogout }) {
  const [paso, setPaso] = useState("inicio"); // inicio | tienda

  if (paso === "tienda") {
    return (
      <div style={styles.bg}>
        <div style={styles.card}>
          <div style={styles.logoArea}>
            <div style={styles.logoCircle}>🔍</div>
            <h1 style={styles.brand}>AUDITORÍAS</h1>
            <p style={styles.sub}>¿Qué tienda vas a auditar?</p>
          </div>
          <div style={styles.grid}>
            {UNIDADES.map(u => (
              <button key={u.id} onClick={() => onElegirTienda(u.id)} style={styles.opcion}
                onMouseEnter={e => { e.currentTarget.style.borderColor = "#C8A96E"; e.currentTarget.style.background = "#1a1610"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = "#2a2a2a"; e.currentTarget.style.background = "#161410"; }}>
                <span style={styles.opcionNombre}>{u.nombre}</span>
              </button>
            ))}
          </div>
          <button style={styles.backBtn} onClick={() => setPaso("inicio")}>← Regresar</button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.bg}>
      <div style={styles.card}>
        <div style={styles.logoArea}>
          <div style={styles.logoCircle}>🍣</div>
          <h1 style={styles.brand}>SUSHIITO</h1>
          <p style={styles.sub}>{nombreUsuario ? `Hola, ${nombreUsuario}` : "Sistema de Administración"}</p>
        </div>

        <button
          onClick={() => setPaso("tienda")}
          style={styles.opcionGrande}
          onMouseEnter={e => { e.currentTarget.style.borderColor = "#C8A96E"; e.currentTarget.style.background = "#1a1610"; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = "#2a2a2a"; e.currentTarget.style.background = "#161410"; }}
        >
          <span style={styles.opcionIcono}>🔍</span>
          <span style={styles.opcionNombre}>AUDITORÍAS</span>
        </button>

        <button style={styles.linkBtn} onClick={onEntrarSistema}>Entrar al sistema completo →</button>
        <button style={styles.logoutBtn} onClick={onLogout}>Cerrar sesión</button>
      </div>
    </div>
  );
}

const styles = {
  bg: { minHeight: "100vh", background: "linear-gradient(135deg, #0a0a0a 0%, #1a1410 50%, #0a0a0a 100%)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: '-apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif', padding: "20px" },
  card: { background: "#111", border: "1px solid #2a2a2a", borderRadius: "16px", padding: "48px 40px", width: "100%", maxWidth: "440px", boxShadow: "0 40px 80px rgba(0,0,0,0.8)" },
  logoArea: { textAlign: "center", marginBottom: "24px" },
  logoCircle: { fontSize: "44px", marginBottom: "12px", display: "block" },
  brand: { color: "#C8A96E", fontSize: "24px", fontWeight: "normal", letterSpacing: "6px", margin: "0 0 6px", fontFamily: '-apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' },
  sub: { color: "#999", fontSize: "14px", margin: 0, letterSpacing: "0.5px", fontFamily: "sans-serif" },
  opcionGrande: { display: "flex", flexDirection: "column", alignItems: "center", gap: "8px", width: "100%", background: "#161410", border: "2px solid #C8A96E", borderRadius: "12px", padding: "28px 18px", cursor: "pointer", transition: "all 0.15s", marginBottom: "16px" },
  opcionIcono: { fontSize: "34px" },
  opcionNombre: { color: "#eee", fontSize: "17px", fontFamily: "sans-serif", fontWeight: "700", letterSpacing: "1px" },
  linkBtn: { width: "100%", background: "transparent", border: "none", color: "#888", fontSize: "13px", cursor: "pointer", fontFamily: "sans-serif", padding: "8px", textAlign: "center" },
  logoutBtn: { width: "100%", background: "transparent", border: "1px solid #2a2a2a", borderRadius: "8px", padding: "12px", color: "#666", fontSize: "13px", cursor: "pointer", fontFamily: "sans-serif", marginTop: "20px" },
  grid: { display: "flex", flexDirection: "column", gap: "10px" },
  opcion: { display: "flex", alignItems: "center", width: "100%", background: "#161410", border: "1px solid #2a2a2a", borderRadius: "10px", padding: "18px", cursor: "pointer", transition: "all 0.15s" },
  backBtn: { width: "100%", background: "transparent", border: "1px solid #2a2a2a", borderRadius: "8px", padding: "12px", color: "#888", fontSize: "13px", cursor: "pointer", fontFamily: "sans-serif", marginTop: "16px" }
};
